export default "__VITE_ASSET__f463a90a__"